// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"a8b78d96","427":"fd5c4b46","430":"eadff38e","453":"a3f87769","542":"3e5c37fc","555":"ad3edbed","681":"83a5f2ed","788":"d24aefee"}[chunkId] + ".chunk.js";
};